import React from 'react'
import { Helmet } from 'react-helmet'
import Box from '@material-ui/core/Box'
import { makeStyles, ThemeProvider } from '@material-ui/core/styles'
import AppSnackbarProvider from 'components/app-snackbar-provider'
import CoachAppbar from 'components/coach-app-bar'
import CondensedFooter from 'components/condensed-footer'
import { withAuthenticatedRoute } from 'lib/auth'
import themes, { extendTheme } from 'themes'
import VirtualCoachingCheckout from './checkout'
import { PAGE_BACKGROUND } from './styles'

const useStyles = makeStyles(() => ({
  root: {
    minHeight: 'calc(100vh - 120px)',
    overflowX: 'clip',
    backgroundColor: PAGE_BACKGROUND,
  },
}))

// Public checkout for a coach's Virtual Coaching offering, at
// /coach/:idOrSlug/purchase/virtual-coaching/:lessonTypeId. It wraps the page
// like the scheduler (`pages/schedule`) so the app bar and footer match, and
// signs the golfer in silently when they already have a session.
const VirtualCoachingCheckoutPage = () => {
  const classes = useStyles()

  return (
    <ThemeProvider theme={extendTheme(themes.pgaCoach)}>
      <Helmet>
        <title>PGA Coach | Virtual Coaching</title>
        <meta name="description" content="PGA Coach | Virtual Coaching" />
        <link rel="icon" href="/pga-coach-favicon.ico" />
      </Helmet>
      <CoachAppbar position="relative" hideContactButton />
      <AppSnackbarProvider
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <ThemeProvider theme={extendTheme(themes.offeringsRefresh)}>
          <Box className={classes.root}>
            <VirtualCoachingCheckout />
          </Box>
        </ThemeProvider>
      </AppSnackbarProvider>
      <CondensedFooter />
    </ThemeProvider>
  )
}

export default withAuthenticatedRoute(VirtualCoachingCheckoutPage)
